// src/modules/migrations.ts
export const CURRENT_SCHEMA_VERSION = 1;

type MigrationFn = (data: Record<string, unknown>) => Record<string, unknown>;

const migrations: Record<number, MigrationFn> = {
  // 未来从 v1→v2 时填充: 1: (data) => ({ ...data, schemaVersion: 2, ...newFields })
};

/**
 * 迁移 localStorage 数据到当前版本。
 * - null / 未识别版本 → null (调用方需 archive 或重置)
 * - 无 version 视为 v1
 */
export function migrate<T = unknown>(data: T): T | null {
  if (data === null || data === undefined) return null;
  // 数组直接透传,避免 {...arr} 把数组变成普通对象,导致 history 等结构丢失数组身份
  if (Array.isArray(data)) return data;
  if (typeof data !== 'object') return null;

  const obj = data as Record<string, unknown>;
  const v = (typeof obj.schemaVersion === 'number' ? obj.schemaVersion : 1);
  if (v > CURRENT_SCHEMA_VERSION) return null;
  let cur: Record<string, unknown> = { ...obj, schemaVersion: v };
  while ((cur.schemaVersion as number) < CURRENT_SCHEMA_VERSION) {
    const fn = migrations[cur.schemaVersion as number];
    if (!fn) return null;
    cur = fn(cur);
  }
  return cur as unknown as T;
}
